import { Component, OnDestroy, EventEmitter, Input, Output, NgZone, SimpleChanges, TemplateRef, ContentChild, OnChanges, ElementRef, ViewChild, forwardRef } from '@angular/core';

import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { NG_VALIDATORS, FormGroup, FormControl, ValidatorFn, Validator } from '@angular/forms';

import { OptionTemplateDirective, SelectedItemTemplateDirective } from './select-helpper.directive';
import { CaracteresEspeciais } from '../../../services/caracteres-especiais';

@Component({
	selector: 'select-helpper',
	templateUrl: './select-helpper.component.html',
	styleUrls: ['./select-helpper.component.scss'],
	providers: [
		{ provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SelectHelpperComponent) },
		{ provide: NG_VALIDATORS, useExisting: SelectHelpperComponent, multi: true }
	]
})
export class SelectHelpperComponent implements ControlValueAccessor, OnChanges, Validator {

	public itemsSelected: any = [];

	public countFiltered = 0;

	public manipulacaoItens = false;

	public results = [];

	public showList: boolean;

	public filt: string = '';

	@ContentChild(OptionTemplateDirective, { read: TemplateRef }) optionTemplate: TemplateRef<any>;
	@ContentChild(SelectedItemTemplateDirective, { read: TemplateRef }) selectedTemplate: TemplateRef<any>;

	// Lista de opções
	@Input() options = [];
	@Input() required:boolean = false;

	// Lista associativa
	public objOptions = {};

	// Multiplo
	@Input() multiple: boolean = false;

	// Nome do atributo chave
	@Input() keyName: string = 'id';
	@Input() name: string = '';
	@Input() placeholder: string = 'Pesquisar';

	// Se for multiplo levar em conta os adicionados, senão nao tem problema
	@Input() filterFn: any;

	// Evento de change
	@Output() onChange = new EventEmitter<any>();

	@ViewChild("filter")
	public filterElementRef: ElementRef;

	constructor(private zone: NgZone, private caracteres: CaracteresEspeciais) {
	}

	ngOnInit() {
		this.filterResults();
	}

	ngOnChanges(changes: SimpleChanges) {

		console.log('changes', changes);

		//if (changes.required) {
		//}
		//if (changes.multiple) {
		//}
		//if (changes.keyName) {
		//}
		//if (changes.filterFn) {
		//}
		if (changes.options) {

			for (let option of this.options)
				this.objOptions[option[this.keyName]] = option;

			setTimeout(() => {
				this.selectedsValidate();
			}, 300);
		}
	}

	removeItem(index?) {

		if (this.multiple)
			this.itemsSelected.splice(index, 1);
		else
			this.itemsSelected = null;

		this.filterResults();
		this.manipulacaoItens = true;

		this.atualizaNgModel();
	}

	addItem(id, index?) {

		if (this.multiple) {
			this.results.splice(index, 1);
			this.itemsSelected.push(id);
			this.manipulacaoItens = true;
			this.filterElementRef.nativeElement.focus();
		} else {
			this.filt = '';
			this.itemsSelected = id;
		}

		this.atualizaNgModel();
	}

	focus(event, focus) {
		setTimeout(() => {
			this.filterResults();
			if (this.manipulacaoItens)
				this.showList = true;
			else
				this.showList = focus;

			if(!this.showList)
				this.filt = '';

			this.manipulacaoItens = false;
		}, 200);
	}

	filterResults() {
		this.results = [];
		let itensFiltrados = [];

		if (this.filterFn && typeof this.filterFn == 'function')
			itensFiltrados = this.filterFn(this.options, this.itemsSelected, this.filt, this.multiple);
		this.countFiltered = itensFiltrados.length;
		this.results = itensFiltrados.slice(0,10);
	}

	selectedsValidate() {
		if (this.multiple) {
			let selecteds = this.itemsSelected;

			for (let id of selecteds)
				if (!this.objOptions[id])
					this.itemsSelected.splice(this.itemsSelected.indexOf(id), 1);
		} else {
			if (!this.objOptions[this.itemsSelected])
				this.itemsSelected = null;
		}
		this.atualizaNgModel();
	}

	// NG MODEL

	propagateChange: any = () => { };

	writeValue(value: any) {
		if (value)
			this.itemsSelected = value;
		else
			this.itemsSelected = this.multiple ? [] : '';
	}

	registerOnChange(fn) {
		this.propagateChange = fn;
	}

	registerOnTouched(fn: () => void): void { }

	atualizaNgModel() {
		this.propagateChange(this.itemsSelected);
		this.onChange.emit(this.itemsSelected);
	}

	// MULTIPLE

    /**
     * selectAll
     *
     * Marca todas as opções
     *
     * @public
     * @author Murilo Spinoza de Arruda
     * @since  07/2018
     * @param  {void}
     * @return {void}
     */
	selectAll() {
		// Reseta os itens selecionados
		this.itemsSelected = [];

		// Percorre cada opção
		for (let id in this.objOptions)
			// Adiciona o id à lista
			this.itemsSelected.push(id);

		// Atualiza o model do componente
		this.atualizaNgModel();
	}

    /**
     * unSelectAll
     *
     * Desmarca todas as opções selecionadas
     *
     * @public
     * @author Murilo Spinoza de Arruda
     * @since  07/2018
     * @param  {void}
     * @return {void}
     */
	unSelectAll() {

		// Reseta os itens selecionados
		this.itemsSelected = [];

		// Atualiza as opções listadas
		this.filterResults();

		// ??
		this.manipulacaoItens = true;

		// Atualiza o model do componente
		this.atualizaNgModel();
	}

	// VALIDACAO


	validate(c?: FormControl) {

		if ((!this.multiple && !this.itemsSelected) || (this.multiple && (!this.itemsSelected || !this.itemsSelected.length)))
			return {required: (this.required && true) };

		return null;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/select-helpper/select-helpper.component.ts